// GameActionButton.tsx
import { motion } from 'framer-motion';
import React, { ReactNode } from 'react';
import styles from './GameActionButton.module.css';

interface GameActionButtonProps {
  leading?: ReactNode;
  children: ReactNode;
  trailing?: ReactNode;
  onClick?: () => void;
  variant?: 'orange' | 'green';
}

export const GameActionButton: React.FC<GameActionButtonProps> = ({
  leading,
  children,
  trailing,
  onClick,
  variant = 'orange',
}) => {
  return (
    <motion.button
      whileTap={{ scale: 0.9 }}
      className={styles.button}
      style={{ backgroundColor: variant === 'orange' ? '#ff7849' : '#23A79C' }}
      onClick={(e) => {
        e.preventDefault(); // Prevent default behavior of touch events, such as show tool bar
        onClick?.();
      }}
    >
      <div className={styles.fade} />
      {leading && <span className={styles.leading}>{leading}</span>}
      <span className={styles.children}>{children}</span>
      {trailing && <span className={styles.trailing}>{trailing}</span>}
    </motion.button>
  );
};
